let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8320Y")).then(() => parcelRequire('iDk8M'));